import { useThemeStore } from './use-theme-store';

export const useThemeMode = () => {
  const mode = useThemeStore(state => state.mode);
  const setMode = useThemeStore(state => state.setMode);

  return { mode, setMode };
};
